import { useQueryClient } from 'react-query';
import { IGlobalConfigCMS, ITechCard, ITechs, usePage } from '../cms';
import { redirectToShoppingCartFromReverseAddress } from './coverageTool';
import { useEffect, useState } from 'react';

const hubFwCustomization = () => {
  const queryClient = useQueryClient();
  const { products } = usePage();
  const allTech = queryClient?.getQueryData('getCmsTecnologies') as ITechs;
  const { globalconfig } = (queryClient?.getQueryData('getGlobalConfigurations') ||
    {}) as IGlobalConfigCMS;
  const placeHolders = allTech?.['fastweb-to-vodafone']?.placeholdergloballis?.elements as {
    key: string;
    value: string;
  }[];
  if (window.location?.pathname?.split('/')?.[1]?.toLowerCase()?.includes('fastweb-vodafone'))
    localStorage.setItem('FFTVH', 'true');
  const queryString = new URLSearchParams(window?.location?.search);
  const cmsid = queryString.get('cmsid') || queryString.get('cmsId') || '';
  const streetFw = queryString.get('street') || '';
  const streetNumberFw = queryString.get('streetNumber') || '';
  const cityFw = queryString.get('city') || '';
  const lat = queryString.get('lat') || '';
  const long = queryString.get('lon') || '';
  const technologyFastweb = queryString.get('technology') || ''; // da rimappare sulle nostre
  const completedAddressFromFw = `${streetFw} ${streetNumberFw} ${cityFw}`;
  let techVf = '';
  let newTitle = '';
  if (technologyFastweb && streetFw && streetNumberFw && cityFw)
    techVf = placeHolders
      ?.find((pl) => pl.key?.toLowerCase() === technologyFastweb?.toLowerCase())
      ?.value?.toLowerCase();
  const silnetLoginRest = queryClient.getQueryData('silentLogin') as any;
  const coexistenceUserRest = queryClient.getQueryData('coexistenceUser') as any;

  newTitle = (allTech?.[techVf] as ITechCard)?.technology?.hubTitleFw?.title || '';

  const productToRedirect = products?.find(
    (prod) =>
      prod.cmsId ===
      globalconfig?.fastwebOfferBinding?.find(
        (offer) => offer?.key?.toLowerCase() === cmsid?.toLowerCase()
      )?.id
  );

  useEffect(() => {
    if (
      productToRedirect?.cmsId &&
      technologyFastweb &&
      streetFw &&
      streetNumberFw &&
      cityFw &&
      lat &&
      long &&
      silnetLoginRest?.flowId &&
      coexistenceUserRest?.userType
    ) {
      redirectToShoppingCartFromReverseAddress(productToRedirect?.cmsId);
    }
  }, [
    lat,
    long,
    productToRedirect,
    technologyFastweb,
    streetFw,
    streetNumberFw,
    cityFw,
    silnetLoginRest,
    coexistenceUserRest,
  ]);

  return {
    addressForFw: completedAddressFromFw,
    techForFw: techVf,
    titleForFw: newTitle ? newTitle?.replace('${ADDRESS}', completedAddressFromFw) : '',
  };
};

export { hubFwCustomization };

